import React from "react";
import { Box, Typography } from "@mui/material";
import { BRAND_COLORS } from "../../utils/brandAssets";
import { MARKETING_COMMUNITY } from "./marketingProductShowcases";
import MarketingReveal, { revealDelay } from "./MarketingReveal";

const MarketingCommunityPreview = () => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
      gap: 2,
    }}
  >
    {MARKETING_COMMUNITY.map((item, index) => (
      <MarketingReveal key={item.title} delay={revealDelay(index, 90)}>
      <Box
        sx={{
          p: 2.5,
          borderRadius: 3,
          border: "1px solid rgba(132, 230, 229, 0.16)",
          bgcolor: "#001018",
          minHeight: 168,
        }}
      >
        <Typography
          variant="overline"
          sx={{ color: BRAND_COLORS.cyan, letterSpacing: 1.3 }}
        >
          {item.kind}
        </Typography>
        <Typography variant="h6" fontWeight={800} sx={{ mt: 0.5, mb: 1 }}>
          {item.title}
        </Typography>
        <Typography variant="body2">{item.detail}</Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
          {item.meta}
        </Typography>
      </Box>
      </MarketingReveal>
    ))}
  </Box>
);

export default MarketingCommunityPreview;
